import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import api from "@/utils/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);

      if (!sessionIdMatch) {
        toast.error("Authentication failed - no session ID");
        navigate("/");
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        const response = await api.post(
          `/auth/google/session?session_id=${sessionId}`
        );

        // Cache non-sensitive display data only
        if (response.data.user) {
          localStorage.setItem('user_data', JSON.stringify(response.data.user));
        }

        toast.success(`Welcome, ${response.data.user?.name || 'User'}!`);

        // Full reload – the httpOnly cookie authenticates the next session
        window.location.href = "/";
      } catch {
        toast.error("Authentication failed. Please try again.");
        navigate("/");
      }
    };

    processAuth();
  }, [location, navigate]);

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center">
      <div className="text-center">
        <div className="spinner mx-auto mb-4" />
        <p className="text-zinc-400">Completing sign in...</p>
      </div>
    </div>
  );
}
